
/**
 * Helper functions to determine test types and distances for Level 2
 */

export const getCorrectDistance = (
  testId: string | null, 
  currentPoint: string,
  distance: string
): string => {
  if (!testId) return distance;
  
  if (testId.includes('wedging')) {
    // Pour les exercices de wedging au Niveau 2
    if (testId === "wedging-cercles") {
      if (currentPoint === "D") return "45m";
      if (currentPoint === "E") return "55m";
      if (currentPoint === "F") return "65m";
      if (currentPoint === "WedgingA") return "45m";
      if (currentPoint === "WedgingB") return "55m";
      if (currentPoint === "WedgingC") return "65m";
    } else if (testId === "wedging-mid") {
      if (currentPoint === "D1") return "75m";
      if (currentPoint === "E1") return "85m";
      if (currentPoint === "F1") return "95m";
    } else if (testId === "wedging-pente-gauche") {
      if (currentPoint === "D2") return "45m";
      if (currentPoint === "E2") return "55m";
      if (currentPoint === "F2") return "65m";
    }
  }
  
  if (testId.includes('bunker')) {
    // Pour les exercices de bunker au Niveau 2
    if (testId === "bunker-court") {
      if (currentPoint === "D") return "5m";
      if (currentPoint === "E") return "8m";
      if (currentPoint === "F") return "12m";
      // Compatibilité avec les points du niveau 3
      if (currentPoint === "BunkerA") return "5m";
      if (currentPoint === "BunkerB") return "8m";
      if (currentPoint === "BunkerC") return "12m";
    } else if (testId === "bunker-long") {
      if (currentPoint === "D1") return "15m";
      if (currentPoint === "E1") return "20m";
      // Compatibilité avec les points du niveau 3
      if (currentPoint === "BunkerD") return "15m";
    }
  }
  
  if (testId.includes('chipping')) {
    // Pour les exercices de chipping au Niveau 2
    if (testId === "chipping-plat") {
      if (currentPoint === "D") return "15m";
      if (currentPoint === "E") return "20m";
      if (currentPoint === "F") return "25m";
      if (currentPoint === "TerPlatA") return "15m";
      if (currentPoint === "TerPlatB") return "20m";
      if (currentPoint === "TerPlatC") return "25m";
    } else if (testId === "chipping-pente-droit") {
      if (currentPoint === "D1") return "15m";
      if (currentPoint === "E1") return "20m";
      if (currentPoint === "F1") return "25m";
    } else if (testId === "chipping-pente-gauche") {
      if (currentPoint === "D2") return "15m";
      if (currentPoint === "E2") return "20m";
      if (currentPoint === "F2") return "25m";
    } else if (testId === "chipping-roulee-plat") {
      if (currentPoint === "D3") return "5m";
      if (currentPoint === "E3") return "10m";
      if (currentPoint === "F3") return "15m";
    }
  }
  
  return distance;
};

export const getFormattedPointForDisplay = (point: string, testId: string | null): string => {
  // Special formatting for wedging points in Level 2
  if (testId && testId.includes('wedging')) {
    if (testId === "wedging-cercles") {
      if (point === "D") return "45m";
      if (point === "E") return "55m";
      if (point === "F") return "65m";
      if (point === "WedgingA") return "45m";
      if (point === "WedgingB") return "55m";
      if (point === "WedgingC") return "65m";
    } else if (testId === "wedging-mid") {
      if (point === "D1") return "75m";
      if (point === "E1") return "85m";
      if (point === "F1") return "95m";
    } else if (testId === "wedging-pente-gauche") {
      if (point === "D2") return "45m";
      if (point === "E2") return "55m";
      if (point === "F2") return "65m";
    }
  }
  
  // Special formatting for chipping points
  if (testId && testId.includes('chipping')) {
    if (testId === "chipping-plat") {
      if (point === "D") return "15m";
      if (point === "E") return "20m";
      if (point === "F") return "25m";
      if (point === "TerPlatA") return "15m";
      if (point === "TerPlatB") return "20m";
      if (point === "TerPlatC") return "25m";
    } else if (testId === "chipping-pente-droit") {
      if (point === "D1") return "15m";
      if (point === "E1") return "20m";
      if (point === "F1") return "25m";
    } else if (testId === "chipping-pente-gauche") {
      if (point === "D2") return "15m";
      if (point === "E2") return "20m";
      if (point === "F2") return "25m";
    } else if (testId === "chipping-roulee-plat") {
      if (point === "D3") return "5m";
      if (point === "E3") return "10m";
      if (point === "F3") return "15m";
    }
  }
  return point;
};

export const getFirstPointForTest = (isPutting: boolean, isChipping: boolean, isWedging: boolean, isBunker: boolean): string => {
  if (isPutting) return 'D';
  if (isChipping) return 'D';
  if (isWedging) return 'D';
  if (isBunker) return 'D';
  return 'D';
};
